// extracted by mini-css-extract-plugin
export default {"policies":"Authentication_policies__33T+n","link":"Authentication_link__Cd8PF","recoverPassword":"Authentication_recoverPassword__lTiDf"};